import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { AttachmentCategoriesDataGrid } from '../../components/datagrid/AttachmentCategoriesDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { AttachmentCategory } from '../../types/attachmentCategory.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function AttachmentCategories() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Attachment categories',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error, mutate } = useSWR<AttachmentCategory[]>(
    `${API_URL.ATTACHMENT_CATEGORY_LIST}?visibleOnly=false`,
    fetcher,
    swrConfig,
  );

  const handleEditButton = (e): void => {
    history.push(`/attachment-categories/edit/${e.row.data.id}`);
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <AttachmentCategoriesDataGrid data={data} handleEdit={handleEditButton} mutateData={mutate} />
    </PageContentWrapper>
  );
}
export default AttachmentCategories;
